// Global browser error handlers — forward to Sentry.
//
// When VITE_SENTRY_DSN is unset, `Sentry.captureException` is a no-op, so this
// file is safe to keep in the build regardless of environment.
//
// Why not rely on Sentry's built-in `GlobalHandlers` integration alone?
// We still want `unhandledrejection` routed through the same path and we want
// a single place to add future side-effects (e.g. toast notifications).
import { Sentry } from "./sentry";

window.addEventListener("error", (event) => {
  Sentry.captureException(event.error || new Error(event.message || "window.error"));
});

window.addEventListener("unhandledrejection", (event) => {
  Sentry.captureException(event.reason || new Error("unhandledrejection"));
});
